import type { RouteConfig } from 'vue-router'

export const routes: RouteConfig[] = [
  {
    path: '/arrival-input',
    name: 'arrival_input',
    component: () => import('@/pages/ArrivalInput/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Arrival Input'
    }
  },
  {
    path: '/sales',
    name: 'sales',
    component: () => import('@/pages/Sales/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Sales'
    }
  },
  {
    path: '/export-label',
    name: 'export_label',
    component: () => import('@/pages/ExportLabel/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Export label'
    }
  },
  {
    path: '/akita-integration',
    name: 'akita_integration',
    component: () => import('@/pages/DataIntegration/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Akita Integration'
    }
  },
  {
    path: '/faj-integration',
    name: 'faj_integration',
    component: () => import('@/pages/DataIntegration/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'FAJ Integration'
    }
  },
  {
    path: '/morioka-integration',
    name: 'morioka_integration',
    component: () => import('@/pages/DataIntegration/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Morioka Integration'
    }
  },
  {
    path: '/sk-integration',
    name: 'sk_integration',
    component: () => import('@/pages/DataIntegration/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'SK Integration'
    }
  },
  {
    path: '/classic-integration',
    name: 'classic_integration',
    component: () => import('@/pages/DataIntegration/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Classic Integration'
    }
  },
  {
    path: '/akita-integration/conversion',
    name: 'akita_conversion',
    component: () => import('@/pages/DataIntegration/AkitaConversion/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Akita Conversion'
    }
  },
  {
    path: '/faj-integration/conversion',
    name: 'faj_conversion',
    component: () => import('@/pages/DataIntegration/FajConversion/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'FAJ Conversion'
    }
  },
  {
    path: '/morioka-integration/conversion',
    name: 'morioka_conversion',
    component: () => import('@/pages/DataIntegration/MoriokaConversion/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Morioka Conversion'
    }
  },
  {
    path: '/sk-integration/conversion',
    name: 'sk_conversion',
    component: () => import('@/pages/DataIntegration/SkConversion/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'SK Conversion'
    }
  },
  {
    path: '/classic-integration/conversion',
    name: 'classic_conversion',
    component: () => import('@/pages/DataIntegration/ClassicConversion/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Classic Conversion'
    }
  },
  {
    path: '/export-peddler-sales',
    name: 'export_peddler_sales',
    component: () => import('@/pages/PeddlerSales/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Export Peddler Sales'
    }
  },
  {
    path: '/export-buyer-sales',
    name: 'export_buyer_sales',
    component: () => import('@/pages/ExportBuyerSales/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Export Buyer Sales'
    }
  },
  {
    path: '/account-receive',
    name: 'account_receive',
    component: () => import('@/pages/AccountReceive/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Account Receive'
    }
  },
  {
    path: '/akakuro-arrival',
    name: 'akakuro_arrival',
    component: () => import('@/pages/AkakuroArrival/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Akakuro Arrival'
    }
  },
  {
    path: '/akakuro-sales',
    name: 'akakuro_sales',
    component: () => import('@/pages/AkakuroSales/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Akakuro Sales'
    }
  },
  {
    path: '/arrival-inquiry',
    name: 'arrival_inquiry',
    component: () => import('@/pages/ArrivalInquiry/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Arrival Inquiry'
    }
  },
  {
    path: '/deposit',
    name: 'deposit',
    component: () => import('@/pages/Deposit/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Deposit'
    }
  },
  {
    path: '/mail-delivery',
    name: 'mail_delivery',
    component: () => import('@/pages/MailDelivery/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Mail Delivery'
    }
  },
  {
    path: '/export-bill',
    name: 'export_bill',
    component: () => import('@/pages/ExportBill/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Bill'
    }
  },
  {
    path: '/sales-inquiry',
    name: 'sales_inquiry',
    component: () => import('@/pages/SalesInquiry/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Sales Inquiry'
    }
  },
  {
    path: '/account-payable',
    name: 'account_payable',
    component: () => import('@/pages/AccountPayable/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Account Payable'
    }
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/pages/Payment/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Payment'
    }
  },
  {
    path: '/daily-update',
    name: 'daily_update',
    component: () => import('@/pages/DailyUpdate/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Daily Update'
    }
  },
  {
    path: '/stock-report',
    name: 'stock_report',
    component: () => import('@/pages/StockReport/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Stock Report'
    }
  }
]
